import type { FunctionComponent, ReactNode } from "react";
import { graphql, useFragment } from "react-relay";

import { checkIsPostiesArticle } from "~/components/article/article-render/posties/helpers";
import { article as articleData } from "~/data/article";
import { useFlag } from "~/lib/feature-flag";
import { useArticleUtils } from "~/lib/hooks/article-utils";
import type { articleFooterArticle$key } from "~/queries/__generated__/articleFooterArticle.graphql";

import { PostiesArticleFooter } from "./posties-article-footer";
import { StyledGenericArticleFooter, StyledMorningStudioArticleFooter } from "./styles";

type Props = {
  articleRecommendation?: {
    articleIds: string[];
    recommendationId: string;
  };
  className?: string;
  divider?: ReactNode;
  reference: articleFooterArticle$key;
};
export const ArticleFooter: FunctionComponent<Props> = ({
  articleRecommendation,
  className,
  divider,
  reference: reference_,
}) => {
  const article = useFragment(
    graphql`
      fragment articleFooterArticle on Article {
        ...articleUtilsArticle
        ...articleMoreStoriesArticle
        ...morningStudioArticleFooterContent
        ...genericArticleFooterArticle
        ...helpersArticleSections
      }
    `,
    reference_,
  );

  const { getArticleType } = useArticleUtils();
  const enableInfiniteScroll = useFlag("enable_infinite_scroll");

  if (checkIsPostiesArticle(article)) {
    return <PostiesArticleFooter className={className} reference={article} />;
  }

  switch (getArticleType(article)) {
    case articleData.types.studio.entityId:
      return (
        <>
          {divider}
          <StyledMorningStudioArticleFooter className={className} reference={article} />
        </>
      );
    default:
      return enableInfiniteScroll && articleRecommendation?.articleIds.length ? (
        <>
          {divider}
          <StyledGenericArticleFooter
            className={className}
            {...articleRecommendation}
            reference={article}
          />
        </>
      ) : null;
  }
};

ArticleFooter.displayName = "ArticleFooter";
